import React from 'react';

const EstimatedRebuildCostInfo = () => (
    <div style={{ overflowY: 'auto', maxHeight: '60vh' }}>
        <h2>How the estimate is calculated</h2>
        <p>
            This rebuild cost estimate is based on your address and considers factors such as the home's size, building materials,
            age, land slope, and other costs associated with rebuilding the home if it were completely destroyed. These costs may
            include:
        </p>
        <ul style={{ display: 'block', paddingLeft: '40px', listStyleType: 'disc' }}>
            <li>Labour and materials required to reconstruct the building.</li>
            <li>Professional fees, such as architects, engineers, and surveyors.</li>
            <li>Debris removal and site clearance.</li>
            <li>Compliance-related costs, including any requirements to meet updated building codes or standards.</li>
            <li>External structures if covered by your policy (e.g., garages, sheds, fences), where applicable.</li>
        </ul>
        <p>
            It does not include the value of the land, and it may differ significantly from the property's total market value.
        </p>
    </div>
);

export default EstimatedRebuildCostInfo;
